export { default } from './BuyingsById';
